import { AnalyticsService, SettingsDto } from '../../services';
import { Auth } from '@nuxtjs/auth-next';

// This plugin initializes the analytics service with Amplitude and Intercom providers.
// Note: This plugin must be loaded after the auth plugin since Intercom is already initialized there with proper user data.
export default (
  {
    $auth,
    $config,
    $gtm,
  }: {
    $auth: Auth & { user: SettingsDto };
    $config: { API_URL: string };
    $gtm: any;
  },
  inject: any,
) => {
  if (!process.client) return;

  if (!$auth) {
    console.error('$auth is null. Please check if the plugin is loaded or if the order of plugins is correct.');
    return;
  }

  const isProduction = $config.API_URL === 'https://api.fourwaves.com';

  const analytics = new AnalyticsService();

  analytics.init({
    amplitudeApiKey: isProduction ? 'fc6e94f05dee6ba377126428e1ed11ba' : '958d7a9e1d1b403c039f36790fce0b7d',
    intercomAppId: 'o9b2hrv8',
    gtmInstance: $gtm ? $gtm : undefined,
    withHubspot: true,
    environment: isProduction ? 'production' : 'development',
    debug: false,
  });

  if ($auth.loggedIn && $auth.user) {
    analytics.identify({
      userId: $auth.user.id,
      email: $auth.user.email,
      firstName: $auth.user.firstName,
      lastName: $auth.user.lastName,
    });
  }

  inject('analytics', analytics);
};
